import axios from 'axios'
import store from 'store'

const apiClient = axios.create({
	baseURL: `${process.env.VUE_APP_API_URL}/api`,
	timeout: 1000 * 50,
})

apiClient.interceptors.request.use((request) => {
	const accessToken = store.get('accessToken')
	if (accessToken) {
		request.headers = {
			...request.headers,
			Authorization: `Bearer ${accessToken}`,
			accesstoken: accessToken,
			'Access-Control-Allow-Origin': true,
		}
	}
	return request
})

export default apiClient
